export default {
    event: 'Événement',
    mailing: 'Courriel',
    sms: 'SMS',
};
